import React from "react"
import LoginActions from "../../login/LoginActions";
import { NewsViewer } from "./NewsViewer";

export default () => {
    React.useEffect(() => {
        LoginActions.setNewsRead();
    }, [])

    return (<div className="container" >
        <div className="card">
            <div className="card-header d-flex bg-theme align-items-center" >
                <h3 className="text-white flex-fill">Novità di CaldaieManager</h3>
            </div>
            <div className="card-body">
                <NewsViewer />
            </div>
        </div>
    </div>)
}